//Use this file to configure the api post-limit query

const postLimitQuery = "/?per_page=100";

export function getPostLimitQuery() {
  return postLimitQuery;
}
